import { persistence as projectPersistenceStorage } from "@restaurant-store-storage";
import { type PersistStorage } from "easy-peasy";

export const persistenceStorage: PersistStorage | undefined =
  projectPersistenceStorage;
